﻿const { setupFilters } = require("./Utils");

var MuWidget = require("mu-widget/lib/MuWidget").MuWidget;
var MuBinder = require("mu-widget/lib/MuBinder").MuBinder;
var MuLabelFor = require("mu-widget/lib/MuLabelFor").MuLabelFor;

MuWidget.registerAll(
	require("./Ui/UiFlash"),
	require("./Ui/UiErrorList"),
	require("./Ui/BaseForm"),
	require("./Ui/UiPrice"),
	require("./Ui/SidebarToggle"),
	require("./Ui/RadioList"),
	require("./Ui/CheckList"),
	require("./Ui/DropdownTender"),
	require("./Ui/MOSelect"),
	require("./Ui/Repeater"),
	require("./Ui/F01_2014"),
	require("./Ui/F02_2014"),
	require("./Ui/F03_2014"),
	require("./Ui/F04_2014"),
	require("./Ui/F05_2014"),
	require("./Ui/F06_2014"),
	require("./Ui/F07_2014"),
	require("./Ui/F08_2014"),
	require("./Ui/F12_2014"),
	require("./Ui/F13_2014"),
	require("./Ui/F14_2014"),
	require("./Ui/F15_2014"),
	require("./Ui/F16_2014"),
	require("./Ui/F17_2014"),
	require("./Ui/F18_2014"),
	require("./Ui/F19_2014"),
	require("./Ui/F20_2014"),
	require("./Ui/F21_2014"),
	require("./Ui/F22_2014"),
	require("./Ui/F23_2014"),
	require("./Ui/F24_2014"),
	require("./Ui/F25_2014"),
	require("./Ui/CZ01_2014"),
	require("./Ui/CZ02_2014"),
	require("./Ui/CZ03_2014"),
	require("./Ui/CZ04_2014"),
	require("./Ui/CZ05_2014"),
	require("./Ui/CZ06_2014"),
	require("./Ui/CZ07_2014"),
	require("./Ui/UiLoginInfo"),
	require("./Ui/UiDialog"),
);

// MuWidget.registerAs(require("./MuWidget/IMuWidget").IMuWidget, ".")
MuWidget.registerAs(require("./BaseWidget").BaseWidget, ".");
MuBinder.register(MuWidget);
setupFilters(MuBinder.filters);
MuLabelFor.register(MuWidget, true);
MuWidget.eventLegacy = false;
var foo = 1;
MuWidget.startup();
